import { formatRupiah } from "../../utils/formatter";

const PropertyDetailInfo = ({ property_type, detailData, property, handleRentClick }) => {
    console.log(property);

    return (
        <div className="col-lg-4">
            <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar--- ">
                <h4 className="title-2">Detail Properti</h4>

                <div className="property-detail-info-list section-bg-1 clearfix mb-60">
                    <ul>
                        {/* APARTMENT (tower, unit, floor, bedrooms, bathrooms, IPL) */}
                        {property_type === "apartement" && (
                            <>
                                <li>
                                    <label>Tower:</label>{" "}
                                    <span>{detailData.tower_name}</span>
                                </li>
                                <li>
                                    <label>Unit:</label>{" "}
                                    <span>{detailData.unit_number}</span>
                                </li>
                                <li>
                                    <label>Floor:</label>{" "}
                                    <span>{detailData.floor_number}</span>
                                </li>
                                <li>
                                    <label>Bedrooms:</label>{" "}
                                    <span>{detailData.bedrooms}</span>
                                </li>
                                <li>
                                    <label>Bathrooms:</label>{" "}
                                    <span>{detailData.bathrooms}</span>
                                </li>
                                <li>
                                    <label>IPL:</label>{" "}
                                    <span>{formatRupiah(detailData.ipl || 0)}</span>
                                </li>
                            </>
                        )}

                        {/* BOARDING / KOST */}
                        {property_type === "boarding" && (
                            <>
                                <li>
                                    <label>Kamar Mandi Dalam:</label>{" "}
                                    <span>
                                        {detailData.has_private_bathroom ? "Ya" : "Tidak"}
                                    </span>
                                </li>
                                {detailData.max_occupants && (
                                    <li>
                                        <label>Maks. Penghuni:</label>{" "}
                                        <span>{detailData.max_occupants} orang</span>
                                    </li>
                                )}
                                {detailData.facilities && (
                                    <li>
                                        <label>Fasilitas:</label>{" "}
                                        <span>
                                            {detailData.facilities}
                                        </span>
                                    </li>
                                )}
                            </>
                        )}

                        {/* HOUSE */}
                        {property_type === "house" && (
                            <>
                                <li>
                                    <label>Bedrooms:</label>{" "}
                                    <span>{detailData.bedrooms}</span>
                                </li>
                                <li>
                                    <label>Bathrooms:</label>{" "}
                                    <span>{detailData.bathrooms}</span>
                                </li>
                                <li>
                                    <label>Floors:</label>{" "}
                                    <span>{detailData.floors}</span>
                                </li>
                                <li>
                                    <label>Garage:</label>{" "}
                                    <span>{detailData.garage ? "Ada" : "Tidak ada"}</span>
                                </li>
                            </>
                        )}

                        {/* COMMERCIAL */}
                        {property_type === "commercial" && (
                            <>
                                <li>
                                    <label>Bathrooms:</label>{" "}
                                    <span>{detailData.bathrooms}</span>
                                </li>
                                <li>
                                    <label>Daya Listrik:</label>{" "}
                                    <span>{detailData.electricity_capacity || "-"}</span>
                                </li>
                                <li>
                                    <label>Kapasitas Parkir:</label>{" "}
                                    <span>
                                        {detailData.parking_capacity
                                            ? `${detailData.parking_capacity} kendaraan`
                                            : "-"}
                                    </span>
                                </li>
                            </>
                        )}

                        {/* Rent Price common */}
                        <li>
                            <label>Rent Price:</label>{" "}
                            <span>{formatRupiah(property?.rent_price || 0)}</span>
                        </li>
                    </ul>
                </div>
                <h4 className="title-2">Sewa Properti</h4>
                <div className="property-detail-info-list section-bg-1 clearfix mb-60 p-4">
                        <div className="mb-30">
                            <div className="add-a-review">
                                <h6>Rental Information</h6>
                            </div>
                            <p>
                                To rent {property.name}, you will need to submit a rental request first.
                                The property manager will review your request, and if approved, you may proceed
                                to the payment stage. A security deposit of {formatRupiah(property.deposit)}
                                will be required.
                            </p>
                        </div>

                        <div className="btn-wrapper mb-30">
                            <button
                                className="btn theme-btn-1 btn-effect-1 text-uppercase"
                                onClick={handleRentClick}
                            >
                                Request Rent
                            </button>
                    </div>
                </div>

            </aside>
        </div>
    );
};

export default PropertyDetailInfo;
